export const primaryShowElement = (delay: number) => {
  return {
    initial: { opacity: 0, scale: 0 },
    animate: { opacity: 1, scale: 1 },
    transition: {
      duration: 0.4,
      delay,
      scale: { type: 'spring', visualDuration: 0.4, bounce: 0.5 },
    },
  }
}

export const showDrawer = (delay: number) => {
  return {
    initial: { y: 1000 },
    animate: { y: 0 },
    transition: {
      duration: 0.4,
      delay,
      scale: { type: 'spring', visualDuration: 0.4, bounce: 0.5 },
    },
  }
}
